<script lang="ts" setup>
  defineProps({
    sections: { type: Array, required: true },
    product: { type: Object, required: true },
    recommended: { type: Array, required: true },
  });
</script>
<template>
  <div class="product-description-nav">
    <a v-if="product.list_attributes.length > 0" class="product-description-nav__to-specification" href="#specification">
      <IconSpecification />
      {{ $t('Specyfikacja') }}</a>
    <a v-if="sections.length > 0" class="product-description-nav__to-specification" href="#description">
      <IconText />
      {{ $t('Opis') }}</a>
    <a v-if="product.reviews_average > 0" class="product-description-nav__to-specification" href="#reviews">
      <IconChatQuote />
      {{ $t('Opinie') }}</a>
    <a v-if="recommended.length > 0" class="product-description-nav__to-specification" href="#recommended">
      <IconPatchCheck />
      {{ $t('Polecane') }}</a>
  </div>
</template>
<style lang="scss" scoped>
  .product-description-nav {
    display: flex;
    gap: 2.5rem;
    font-size: 0.875rem;
    line-height: 2;
    font-weight: var(--font-weight-500);
    padding: 0.75rem 0;
    background-color: var(--color-white);

    a {
      position: relative;
      display: flex;
      align-items: center;
      gap: 0.5rem;

      &::after {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        width: 0;
        height: 2px;
        background-color: var(--primary-color);
        transition-property: width;
        transition-duration: var(--transition-primary-duration);
        transition-timing-function: var(--transition-primary-timing-function);
      }

      @media(hover: hover) {
        &:hover::after {
          width: 100%;
        }
      }
    }
  }

  @media(max-width: 992px) {
    .product-description-nav {
      gap: 1.5rem;
      font-size: 0.75rem;
      padding: 0.5rem 1rem;
      overflow-x: auto;
      scrollbar-width: none;
      -ms-overflow-style: none;

      &::-webkit-scrollbar {
        display: none;
      }

      a {
        word-break: keep-all;
        white-space: nowrap;
      }
    }
  }
</style>